var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.97 21.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ab2626;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.82,21.41a27.74,27.74,0,0,1-4-.3,3.24,3.24,0,0,1-2.73-3.22V7.2a.8.8,0,0,1,1.6,0V17.89a1.62,1.62,0,0,0,1.36,1.63,25.56,25.56,0,0,0,7.76,0,1.65,1.65,0,0,0,1.4-1.64V7.2a.8.8,0,1,1,1.6,0V17.86a3.26,3.26,0,0,1-2.79,3.23A31.71,31.71,0,0,1,8.82,21.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.32,4.38C15.55,4,14,3.77,12.51,3.61a.17.17,0,0,0,0-.07,3.55,3.55,0,0,0-7.09,0,.28.28,0,0,0,0,.09c-1.46.15-3,.4-4.8.75A.81.81,0,0,0,0,5.32.8.8,0,0,0,1,6,34.54,34.54,0,0,1,17,6l.16,0A.8.8,0,0,0,18,5.33.81.81,0,0,0,17.32,4.38ZM7,3.48a2,2,0,0,1,3.9,0A29.86,29.86,0,0,0,7,3.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.92,17.4a.8.8,0,0,1-.8-.8v-8a.8.8,0,0,1,1.6,0v8A.8.8,0,0,1,10.92,17.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.05,17.4a.8.8,0,0,1-.8-.8v-8a.8.8,0,1,1,1.6,0v8A.8.8,0,0,1,7.05,17.4Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/Delete.e674e41d57769db03be835c6f65f5538.svg";
export { ForwardRef as ReactComponent };